export const GET_PROFILE = 'GET_PROFILE'
export const ONBOARDING = 'ONBOARDING'
export const ACTIVE_NOTIF_VIEW = 'ACTIVE_NOTIF_VIEW'
export const RESET_PROFILE_ACTION = 'RESET_PROFILE_ACTION'
export const GET_PROFILE_BY_USER = 'GET_PROFILE_BY_USER'

// Mutations
export const SAVE_PROFILE = 'SAVE_PROFILE'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const RESET_PROFILE = 'RESET_PROFILE'



// WEBPACK FOOTER //
// ./src/store/actions/profileQueries.js